import React from "react";
import { Container } from "react-bootstrap";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import LayoutTwo from "../../layouts/LayoutTwo";
import HeroSlider from "../../wrappers/HeroSlider";
import { useLocation } from "react-router-dom";
// import img from "../../assets/images/career/attachment 1.png";
import "../../../src/assets/css/career.css";

const Career = () => {
  let { pathname } = useLocation();
  let data = [
    {
      cad: "CAD DESIGNER",
      openings: "OPENING: 10",
      disc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris",
    },
    {
      cad: "CAD DESIGNER",
      openings: "OPENING: 10",
      disc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris",
    },
    {
      cad: "CAD DESIGNER",
      openings: "OPENING: 10",
      disc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris",
    },
  ];

  return (
    <div className="career_main">
      <LayoutTwo>
        <HeroSlider />
        <Container className="main_section_career">
          <Breadcrumb
            pages={[
              { label: "Home", path: "/" },
              { label: "Career", path: pathname },
            ]}
          />

          <div className="career_grid">
            <div>
              <h4 className="job_font">JOB OPENINGS</h4>

              {data.map((el, index) => {
                return (
                  <div key={index} className={`career-item`}>
                    <h5 className="cad_font">{el.cad}</h5>
                    <h6 className="opening_font">{el.openings}</h6>
                    <p className="dicription">{el.disc}</p>
                  </div>
                );
              })}
            </div>

            <div className="input_fill">
              <h4 className="input_fill_title">Fill the following to Apply</h4>
              <input type="text" placeholder="Enter your First Name" />
              <input
                type="number"
                placeholder="Enter your Phone Number"
                className="mobile_number"
              />
              <select name="" id="selcter">
                <option value="">Applying For?</option>
                <option value="">Applying Job</option>
                <option value="">Applying Assistance</option>
                <option value="">Applying Help Desk</option>
              </select>
              <button className="submit_btn desktop_btn button primary_btn">
                SUBMIT
              </button>
            </div>

            <div className="input_fill_third_grid">
              <input type="text" placeholder="Enter your Last Name" />
              <input
                type="email"
                placeholder="Enter your Email Id"
                className="email"
              />
              <input type="file" id="fileInput" />
              <button className="submit_btn mobile_btn button primary_btn">
                SUBMIT
              </button>
            </div>
          </div>
        </Container>
      </LayoutTwo>
    </div>
  );
};

export default Career;
